// import router from '@/router'

// this.$store.state['iocSearch/iocSearchAddress']
// import isURL from 'validator/es/lib/isURL'

const state = () => ({
    address: null,
    isOpenIocSearchModal: false,
    // results: null,
    // hasResults: false,
    // error: null,
    // isLoading: false,
})

// this.$store.getters['iocSearch/isOpenIocSearchModal']
const getters = {
    /*
     isLoading: state => {
     return state.isLoading
     },
     */
    /*
     hasResults: state => {
     return state.hasResults
     },
     */
    /*
     results: state => {
     return state.results
     },
     */
    /*
     hasError: state => {
     return state.error !== null
     },
     */
    /*
     error: state => {
     return state.error
     },
     */
    address: state => {
        return state.address
    },
    isOpenIocSearchModal: state => {
        return state.isOpenIocSearchModal
    },

}

// this.$store.dispatch('iocSearch/closeIocSearchModal')
const actions = {
    /*
     search(context, address) {
     // current_ip: /search/ioc/ip/{ip}
     let apiEndpoint
     if (isIP(address)) {
     apiEndpoint = `/search/ioc/ip/${ address }`
     } else if (isFQDN(address)) {
     apiEndpoint = `/search/ioc/domain/${ address }`
     }

     Axios.get(apiEndpoint)
     .then(response => {
     console.log('VUEX searchIp response', response.data)
     context.commit('SET_RESULTS', response.data)
     context.commit('SET_HAS_RESULTS', true)
     })
     .finally(() => {
     context.commit('SET_IS_LOADING', false)
     })
     },
     */

    openIocSearchModal(context, address) {
        // console.log('vuex openIocSearchModal', iocSearchAddress)
        // context.commit('SET_IOC_SEARCH_ADDRESS', iocSearchAddress)
        // console.log('vuex state.iocSearchAddress', context.state.iocSearchAddress)
        context.commit('SET_IS_OPEN_IOC_SEARCH_MODAL', true)
    },
    closeIocSearchModal(context) {
        // console.log('vuex closeIocSearchModal')
        context.commit('SET_IS_OPEN_IOC_SEARCH_MODAL', false)
        // context.commit('SET_IOC_SEARCH_ADDRESS', null)
        // console.log('vuex closeIocSearchModal', context.getters.iocSearchAddress)
    },
    setAddress(context, address) {
        context.commit('SET_IOC_SEARCH_ADDRESS', address)
    },
    /*
     clearAddress(context) {
     context.commit('SET_IOC_SEARCH_ADDRESS', null)
     },
     */
    /*
     resetResults(context) {
     context.commit('SET_RESULTS', null)
     context.commit('SET_HAS_RESULTS', false)
     },
     */
    /*
     setHasResults(context, hasResults) {
     context.commit('SET_HAS_RESULTS', hasResults)
     },
     */
}

// this.$store.commit('iocSearch/SET_IS_OPEN_IOC_SEARCH_MODAL', false)
const mutations = {
    /*
     SET_IS_LOADING: (state, isLoading) => {
     state.isLoading = isLoading
     },
     */
    /*
     SET_RESULTS: (state, results) => {
     // console.log('VUEX SET_RESULTS results', results)
     state.results = results
     },
     */
    /*
     SET_HAS_RESULTS: (state, hasResults) => {
     // console.log('VUEX SET_HAS_RESULTS hasResults', hasResults)
     state.hasResults = hasResults
     },
     */
    SET_IOC_SEARCH_ADDRESS: (state, address) => {
        state.address = address
    },
    SET_IS_OPEN_IOC_SEARCH_MODAL: (state, isOpenIocSearchModal) => {
        state.isOpenIocSearchModal = isOpenIocSearchModal
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

